import { ReactElement, useMemo } from 'react';

import { EducationalMaterial } from '@dreryk/egabinet-knowledge-base-frontend-api';

import { StaticDataConfiguration, Table } from '@dreryk/react-components';

import { EducationalMaterialRemoveHandler } from '../table/EducationalMaterialsTable.types';

import { useEducationalMaterialShareFormTableColumns } from './EducationalMaterialShareFormTable.hooks';

type EducationalMaterialShareFormTableProps = Readonly<{
   educationalMaterials: EducationalMaterial[];
   onEducationalMaterialRemoved?: EducationalMaterialRemoveHandler;
   closeModal: VoidFunction;
}>;

export const EducationalMaterialShareFormTable = (props: EducationalMaterialShareFormTableProps): ReactElement => {
   const dataConfiguration = useMemo<StaticDataConfiguration<EducationalMaterial>>(
      () => ({ data: props.educationalMaterials }),
      [props.educationalMaterials]
   );
   const columns = useEducationalMaterialShareFormTableColumns({
      onRemoveRow: props.onEducationalMaterialRemoved,
      closeModal: props.closeModal,
   });

   return (
      <Table<EducationalMaterial>
         columns={columns}
         dataConfiguration={dataConfiguration}
         keyExtractor={'id'}
         testId={'educationalMaterialShareFormTable'}
         compact
      />
   );
};
